import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { withRouter, Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import classNames from 'classnames';

import Spinner from '../spinner';

// Import actions
import { updateMyOrganizationSyncType } from '../../modules/App/AppActions';

// Import Selectors
import { getUser } from '../../modules/Auth/AuthReducer';

export default function (ComposedComponent) {
  class RequiredSetupOrg extends Component {
    constructor() {
      super();
      this.state = {
        show: true,
        type: 'detailed',
        dirty: false,
        loading: false,
      };
      this.done = this.done.bind(this);
      this.continue = this.continue.bind(this);
      this.selectType = this.selectType.bind(this);
    }

    done() {
      // this.setState({ show: false });
      // defer(this.context.router.push, '/logout');
    }
    continue() {
      const { type } = this.state;
      this.setState({ loading: true });
      this.props.dispatch(updateMyOrganizationSyncType(type))
        .then(() => { this.setState({ loading: false, show: false }); });
    }

    selectType(type) {
      this.setState({ type, dirty: true });
    }

    renderNotice() {
      const {
        show, type, dirty, loading,
      } = this.state;
      const { user } = this.props;
      const summaryCls = classNames({
        btn: true,
        'btn-default': true,
        'btn-sm': true,
        active: type === 'summary',
      });
      const detailedCls = classNames({
        btn: true,
        'btn-sm': true,
        'btn-default': true,
        active: type === 'detailed',
      });
      return (
        <div>
          <Helmet
            title="Organization Settings"
            titleTemplate="%s - TruSales"
            meta={[
              { charset: 'utf-8' },
              {
                'http-equiv': 'X-UA-Compatible',
                content: 'IE=edge',
              },
              {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1',
              },
            ]}
          />
          <Modal show={show} onHide={this.done}>
            <Modal.Header>
              <h4>Welcome</h4>
            </Modal.Header>
            <Modal.Body>
              <div>
                <p><strong>Hi {user.display_name},</strong></p>
                <p>Before you start, please specify how you want to sync your organization data:</p>
                <div>
                  <p className="btn-group">
                    <button type="button" className={summaryCls} onClick={() => { this.selectType('summary'); }}>
                      {type === 'summary' && <Fa name="check-circle-o" className="text-success" />}
                      &nbsp;Summary Data
                    </button>
                    <button type="button" className={detailedCls} onClick={() => { this.selectType('detailed'); }}>
                      {type === 'detailed' && <Fa name="check-circle-o" className="text-success" />}
                      &nbsp;Detailed Data
                    </button>
                  </p>
                  <div className="panel panel-info">
                    <div className="panel-body">
                      {type === 'summary' &&
                        <div>
                          Summary data does not include ANY data that can be used to identify
                          an account, opportunity or a sales representative.
                        </div>
                      }
                      {type === 'detailed' &&
                        <div>
                          Detailed data collects sales representative names, opportunity names,
                          and account names to allow for deeper analysis of your organization&rsquo;s data
                        </div>
                      }
                    </div>
                  </div>
                </div>
                {dirty &&
                  <div className="text-danger">
                    <Fa name="exclamation-triangle" /> Please notice that you <strong>CANNOT</strong> change this setting later.
                  </div>
                }
              </div>
            </Modal.Body>
            <Modal.Footer>
              {!loading &&
                <div className="clearfix">
                  <Link to="/logout" className="pull-left btn btn-lg btn-link">Logout</Link>
                  <Button disabled={loading} onClick={this.continue} className="pull-right" bsSize="large" bsStyle="primary">
                    Continue <Fa name="arrow-right" />
                  </Button>
                </div>
              }
              {loading && <div className="text-center"><Spinner /></div>}
            </Modal.Footer>
          </Modal>
        </div>
      );
    }

    render() {
      const { user } = this.props;
      const { user: { organization } } = this.props;
      const userAlreadyLogin = user && user._id;
      const syncType = organization ? organization.sync_type : '';
      const isLogout = this.props.location.pathname === '/logout';
      if (!isLogout && userAlreadyLogin && syncType !== 'summary' && syncType !== 'detailed') {
        return this.renderNotice();
      }
      return <ComposedComponent {... this.props} />;
    }
  }

  // Retrieve data from store as props
  function mapStateToProps(state) {
    return {
      user: getUser(state),
    };
  }

  RequiredSetupOrg.propTypes = {
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.shape({
      user_id: PropTypes.string,
      organization: PropTypes.shape({}),
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  };


  RequiredSetupOrg.contextTypes = {
  };


  return withRouter(connect(mapStateToProps)(RequiredSetupOrg));
}
